import { apiClient } from '@/shared/api/apiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { USER_SESSION_QUERY_KEY } from '@/features/auth/hooks/useAuth'

export function useSendEmailVerificationCode() {
  return useMutation({
    mutationFn: async () => {
      const response = await apiClient.post('v1/user/email-verification/send-code')
      return response.data
    }
  })
}

export function useVerifyEmailWithCode() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (code: string) => {
      const response = await apiClient.post('v1/user/email-verification/verify-code', {
        verificationCode: code
      })

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USER_SESSION_QUERY_KEY] })
    }
  })
}
